import { Component } from '@angular/core';
import { IWizItemRenderer} from '@wizeoo/akm-component-lib';
import { ConnectVO } from '../../../vo/core/connect.vo';
import { FreedataValueVO } from '../../../vo/core/freedatavalue.vo';

@Component({
  selector: 'connect-small-renderer',
  templateUrl: './connect-small.renderer.html'
})
export class ConnectSmallRenderer implements IWizItemRenderer<null, [ConnectVO, FreedataValueVO]> {
  public data: [ConnectVO, FreedataValueVO]; // datas from owner
}
